<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Header from "../components/Header.svelte";
    import * as common from "../utiles/common.util";
    import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
    import * as store from "../stores/store";

    export let params;

    let rcept_NO = params.rcept_NO;
    let rcept_SN = params.rcept_SN;

    let ITEM_NM = "";
    let LCLAS_CODE = "";

    let TRV_EXP = "";

    let pageSize = 20; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지
    let currentList = [];
    let dataList = [];

    let quantities = {}; // 수량 상태
    let qyRefs = []; // 수량 input 참조 배열
    let rmRefs = []; // 비고 input 참조 배열
    let untpcRefs = [];

    onMount(() => {
        getData();
    });

    async function getData() {
        const response = await api.get(
            `/item/${rcept_NO}?&RCEPT_SN=${rcept_SN}&TRV_EXP=Y`
        );

        if (response != null) {
            if (response.searchVO != null) {
                TRV_EXP = response.searchVO.untpc;
            }

            if (JSON.stringify(response.data) !== JSON.stringify(dataList)) {
                currentPage = 0;
                currentList = [];

                dataList = [];
                dataList = response.data.map((item) => ({
                    ...item,
                    checked: item.item_CODE !== "2025050030",
                }));
                loadMore();
            }
        }
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        currentList = [...currentList, ...dataList.slice(start, end)];
        currentPage++;

        currentList.forEach((v) => {
            if (v.item_CODE !== "2025050030") {
                quantities[v.item_CODE] = v.qy ?? 0;
            }
        });
    }

    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList.length < dataList.length) {
                loadMore();
            }
        }
    }

    function toggleCheck(index) {
        currentList[index].checked = !currentList[index].checked;
    }

    function getCheckedItems() {
        for (let i = 0; i < currentList.length; i++) {
            if (currentList[i].checked && !qyRefs[i]?.value) {
                alert(
                    `수량을 입력하지 않은 항목이 있습니다.\n${currentList[i].item_NM}`
                );
                return []; // 함수 종료
            }
        }

        const result = currentList
            .map((v, i) => {
                if (v.checked) {
                    return {
                        item_CODE: v.item_CODE,
                        item_NM: v.item_NM,
                        item_code_sn: v.item_SN,
                        qy: qyRefs[i]?.value || "",
                        rm: rmRefs[i]?.value || "",
                        untpc: untpcRefs[i]?.value || "",
                    };
                }
            })
            .filter(Boolean);

        // 출장비
        result.unshift({
            item_CODE: "2025050030",
            item_NM: "출장비",
            item_code_sn: "1",
            qy: 1,
            rm: "",
            untpc: Number(TRV_EXP),
        });

        return result;
    }

    async function saveClick() {
        let item_list = getCheckedItems();

        const formData = new FormData();
        formData.append("RCEPT_NO", rcept_NO);
        formData.append("RCEPT_SN", rcept_SN);

        item_list.forEach((item, idx) => {
            formData.append(`item_list[${idx}].ITEM_CODE`, item.item_CODE);
            formData.append(`item_list[${idx}].ITEM_NM`, item.item_NM);
            formData.append(
                `item_list[${idx}].ITEM_CODE_SN`,
                item.item_code_sn
            );
            formData.append(`item_list[${idx}].QY`, item.qy);
            formData.append(`item_list[${idx}].RM`, item.rm);
            formData.append(`item_list[${idx}].UNTPC`, item.untpc);
        });

        const response = await api.post("/item/put", formData);

        if (response != null) {
            if (Capacitor.isNativePlatform()) {
            }

            alert("사용 부품이 수정되었습니다.");

            push(`/AsDtl/${rcept_NO}/${rcept_SN}`);
        } else {
            alert(response.msg);
        }
    }

    function goBack() {
        push(`/AsDtl/${rcept_NO}/${rcept_SN}`);
    }

    // 페이지가 로드될 때 goBack 등록
    store.currentGoBack.set(goBack);

    // 페이지 벗어나면 해제
    onDestroy(() => {
        store.currentGoBack.set(null);
    });
</script>

<Header {goBack} />

<!-- svelte-ignore a11y-missing-attribute -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-label-has-associated-control -->
<section
    class="main inner main-pad-36 main-gray scroll-custom"
    style="width: 100%; position: relative; height: 85vh; overflow-y: auto"
    on:scroll={handleScroll}
>
    <div class="mobile">
        <div style="background: #FFF;">
            <div class="cmn-title-left gray-width" style="padding-top: 10px;">
                <p>부품 수정</p>
            </div>

            <div
                class="cmn-input"
                style="width: 90%; margin: 10px auto; height: 65px;"
            >
                <input
                    bind:value={TRV_EXP}
                    type="number"
                    style="height: 40px;"
                    placeholder="출장비 입력해 주세요. (미입력 시 0원)"
                />
            </div>
        </div>

        <div id="item-list_m">
            {#if currentList.length > 0}
                {#each currentList.filter((v) => v.item_CODE != "2025050030") as data, i}
                    <div
                        style="margin-top: 15px; background: #FFF;"
                        on:click={() => toggleCheck(i)}
                    >
                        <div class="gray-width">
                            <div class="cart-order-list">
                                <div class="order-dtl">
                                    <input
                                        type="checkbox"
                                        name="item"
                                        style="display:block"
                                        bind:checked={data.checked}
                                        value={data.item_CODE}
                                        on:click|stopPropagation
                                    />
                                </div>

                                <ul>
                                    <li>
                                        <div class="list-in">
                                            <p class="list-title">품목코드</p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p>{data.item_CODE}</p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">품명</p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p>{data.item_NM}</p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">규격</p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p>
                                                {data.stndrd ? data.stndrd : ""}
                                            </p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">단가</p>
                                        </div>
                                        <div class="list-in">
                                            <input
                                                type="number"
                                                bind:this={untpcRefs[i]}
                                                bind:value={data.untpc}
                                                style="border: 1px solid var(--line, #ECECEC);"
                                                on:click|stopPropagation
                                            />
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">수량</p>
                                        </div>
                                        <div class="list-in">
                                            <button
                                                type="button"
                                                class="btn-minus"
                                                on:click|stopPropagation={() => {
                                                    if (
                                                        quantities[
                                                            data.item_CODE
                                                        ] > 1
                                                    )
                                                        quantities[
                                                            data.item_CODE
                                                        ]--;
                                                }}
                                            >
                                                -
                                            </button>

                                            <input
                                                type="number"
                                                min="1"
                                                bind:this={qyRefs[i]}
                                                bind:value={
                                                    quantities[data.item_CODE]
                                                }
                                                style="border: 1px solid var(--line, #ECECEC); text-align: center;"
                                                on:click|stopPropagation
                                            />

                                            <button
                                                type="button"
                                                class="btn-plus"
                                                on:click|stopPropagation={() =>
                                                    quantities[
                                                        data.item_CODE
                                                    ]++}
                                            >
                                                +
                                            </button>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">비고</p>
                                        </div>
                                        <div class="list-in">
                                            <input
                                                type="text"
                                                bind:this={rmRefs[i]}
                                                bind:value={data.rm}
                                                style="border: 1px solid var(--line, #ECECEC);"
                                                on:click|stopPropagation
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                {/each}
            {:else}
                <p>검색 결과가 없습니다.</p>
            {/if}

            <div class="cmn-btn cmn-btn-btm">
                <button
                    on:click={() => {
                        saveClick();
                    }}
                >
                    부품 수정
                </button>
            </div>
        </div>
    </div>
</section>

<style>
    p {
        white-space: unset;
    }

    .list-in_ {
        border-bottom: 1px solid;
    }

    .btn-plus {
        width: 38px;
        height: 30px;
        border: 1px solid #ccc;
        background: #fff;
        cursor: pointer;
        margin-left: 20px;
    }

    .btn-minus {
        width: 38px;
        height: 30px;
        border: 1px solid #ccc;
        background: #fff;
        cursor: pointer;
        margin-right: 20px;
    }
</style>
